import { $Q, $Qll } from '../utils/query-selector';
import api from '../services/api';
import { handleToggleDescriptionPopup, validateSizeDescription } from './toggle-description';

/**
 * Renders product section inside the popup
 * @param {obj} e - event object
 * @param {node} card - product card
 */
async function openComposerPopup(e, card) {
  e.preventDefault();

  const parent = e.target.classList.contains('click-event')
    ? e.target
    : e.target.closest('.click-event');

  // ? Get default data to popup
  const imageUrl = parent.getAttribute("data-image")
  const subtitle = parent.getAttribute("data-subtitle")
  const titleDescription = parent.getAttribute("data-titledescription")
  const buttonShow = parent.getAttribute("data-buttonshow")
  const buttonHide = parent.getAttribute("data-buttonhide")

  const composerPopup = $Q('#composer-popup');
  const composerContent = $Q('.modal-content > .modal-inject-area', composerPopup);

  composerPopup.classList.add('active', 'loading');

  const url = card.getAttribute('data-product');
  const productInfo = await api.shopifySectionByUrl(`/products/${url}`, 'product-popup');
  composerContent.innerHTML = productInfo;

  handleToggleDescriptionPopup('.product-popup-content__detail')

  // ? Replace all default data
  $Q(".product-popup-content__media .image-popup").removeAttribute("srcset")
  $Q(".product-popup-content__media .image-popup").removeAttribute("data-srcset")
  $Q(".product-popup-content__media .image-popup").src = imageUrl
  $Q(".product-popup-content__detail .product-popup-content__subtitle").innerHTML = subtitle
  $Q(".product-popup-content__detail .title-description").innerHTML = titleDescription
  $Q(".product-popup-content__detail .text").innerHTML = buttonShow
  $Q(".product-popup-content__detail .toggle-text").setAttribute("data-show", buttonShow)
  $Q(".product-popup-content__detail .toggle-text").setAttribute("data-hide", buttonHide)

  validateSizeDescription($Q(".product-popup-content__detail .toggle-text", composerPopup))

  composerPopup.classList.remove('loading');
}

/**
 * Handles click event on the product card
 */
export const composerPopup = (classContainer = '.main-packmix') => {
  const gridContainer = $Q(classContainer);

  if (!gridContainer) return false;

  $Qll('.pack-composers .click-event').forEach(
    (card) => {
      card.addEventListener(
        'click',
        (e) => {
          openComposerPopup(e, card);
        },
      )
    },
  )
}
